import SiteNavbar from "@/components/SiteNavbar";
import { SiLine, SiFacebook } from "react-icons/si";

const IMAGES = {
  gs6: "https://static-us-img.skywork.ai/prod/nexus/1781619877/cropped_image_0_1781619877112854842.jpg",
  gf6: "https://static-us-img.skywork.ai/prod/nexus/1781619876/cropped_image_1_1781619876918596078.jpg",
  r60: "https://static-us-img.skywork.ai/prod/nexus/1781619876/cropped_image_1_1781619876715520058.jpg",
  mt6: "https://static-us-img.skywork.ai/prod/nexus/1781619875/cropped_image_14_1781619875377708650.jpg",
};

const models = [
  {
    id: "gs6",
    name: "GS6",
    type: "6-Piston Street Performance",
    img: IMAGES.gs6,
    desc: "คาลิปเปอร์ 6 ลูกสูบสำหรับใช้งานบนถนน และ Track Day สมรรถนะสูง",
    spec: {
      pistons: "2×31.8mm / 2×31.8mm / 2×41.3mm",
      area: "58 cm²",
      disc: "φ380–400 mm",
      weight: "3.9 kg",
    },
    warranty: "โครงสร้างคาลิปเปอร์ 5 ปี",
    badgeColor: "#E8212A",
    badge: "Street",
  },
  {
    id: "gf6",
    name: "GF6",
    type: "6-Piston Offroad Specialist",
    img: IMAGES.gf6,
    desc: "คาลิปเปอร์ 6 ลูกสูบออกแบบพิเศษสำหรับรถออฟโรด มีทั้งรุ่น Forged Aluminum และ Cast Iron",
    spec: {
      pistons: "2×36mm / 2×38mm / 2×41.3mm",
      area: "69 cm²",
      disc: "φ335–355 mm",
      weight: "3.9–9.2 kg",
    },
    warranty: "โครงสร้างคาลิปเปอร์ 5 ปี",
    badgeColor: "#16a34a",
    badge: "Offroad",
  },
  {
    id: "r60",
    name: "R60",
    type: "6-Piston Forged Mono-Block",
    img: IMAGES.r60,
    desc: "คาลิปเปอร์ 6 ลูกสูบ Forged Mono-Block ตัวเดียว แข็งแกร่งสูงสุด เหมาะสำหรับ Track Day",
    spec: {
      pistons: "2×27mm / 2×31.8mm / 2×38mm",
      area: "50 cm²",
      disc: "φ355–378 mm",
      weight: "3.5 kg",
    },
    warranty: "โครงสร้างคาลิปเปอร์ 5 ปี",
    badgeColor: "#7c3aed",
    badge: "Track",
  },
  {
    id: "mt6",
    name: "MT6",
    type: "6-Piston Performance",
    img: IMAGES.mt6,
    desc: "คาลิปเปอร์ 6 ลูกสูบสมรรถนะสูง น้ำหนักเบา เหมาะสำหรับการใช้งานบนถนนและ Track",
    spec: {
      pistons: "2×27mm / 2×31.8mm / 2×38.1mm",
      area: "50 cm²",
      disc: "φ355–378 mm",
      weight: "3.5 kg",
    },
    warranty: "โครงสร้างคาลิปเปอร์ 5 ปี",
    badgeColor: "#0891b2",
    badge: "Performance",
  },
];

const colorOptions = [
  { label: "แดง", color: "#E8212A", emoji: "🔴" },
  { label: "น้ำเงิน", color: "#2563eb", emoji: "🔵" },
  { label: "เขียว", color: "#16a34a", emoji: "🟢" },
  { label: "เหลือง", color: "#eab308", emoji: "🟡" },
  { label: "ส้ม", color: "#ea580c", emoji: "🟠" },
  { label: "เงิน", color: "#a1a1aa", emoji: "⚪" },
  { label: "ดำ", color: "#18181b", emoji: "⚫" },
  { label: "ขาว", color: "#f4f4f5", emoji: "⬜" },
];

const Index = () => {
  return (
    <div style={{ background: "#0D0D0D", minHeight: "100vh", fontFamily: "Rajdhani, sans-serif" }}>
      <SiteNavbar currentPage="/#/motve" />

      {/* Hero */}
      <section
        style={{
          background: "linear-gradient(135deg, #0D0D0D 0%, #1a0505 100%)",
          paddingTop: "120px",
          paddingBottom: "60px",
          textAlign: "center",
          borderBottom: "1px solid rgba(232,33,42,0.2)",
        }}
      >
        <div className="container mx-auto px-4">
          <p
            style={{
              color: "#E8212A",
              fontSize: "13px",
              letterSpacing: "0.3em",
              textTransform: "uppercase",
              fontWeight: 700,
              marginBottom: "16px",
              fontFamily: "Rajdhani, sans-serif",
            }}
          >
            Official Thailand Distributor
          </p>
          <h1
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "clamp(36px, 7vw, 80px)",
              fontWeight: 700,
              color: "#fff",
              lineHeight: 1.05,
              marginBottom: "20px",
              textShadow: "0 4px 40px rgba(0,0,0,0.8)",
            }}
          >
            MOTVE <span style={{ color: "#E8212A" }}>BRAKE</span> SYSTEMS
          </h1>
          <p
            style={{
              fontFamily: "Sarabun, sans-serif",
              fontSize: "clamp(15px, 2.5vw, 20px)",
              color: "rgba(255,255,255,0.75)",
              maxWidth: "560px",
              margin: "0 auto 0",
              lineHeight: 1.7,
            }}
          >
            ตัวแทนจำหน่าย MOTVE อย่างเป็นทางการในประเทศไทย
          </p>
          <p
            style={{
              fontFamily: "Sarabun, sans-serif",
              fontSize: "16px",
              color: "rgba(255,255,255,0.5)",
              maxWidth: "560px",
              margin: "12px auto 0",
              lineHeight: 1.7,
            }}
          >
            ระบบเบรกสมรรถนะสูงสำหรับรถยนต์บนถนนและสนามแข่ง — คาลิปเปอร์ 6 ลูกสูบ คุณภาพระดับนานาชาติ
          </p>
        </div>
      </section>

      {/* Models Grid */}
      <section style={{ padding: "80px 0" }}>
        <div className="container mx-auto px-4">
          <div style={{ textAlign: "center", marginBottom: "56px" }}>
            <h2
              style={{
                fontFamily: "Rajdhani, sans-serif",
                fontSize: "clamp(28px, 5vw, 52px)",
                fontWeight: 700,
                color: "#fff",
                lineHeight: 1.1,
              }}
            >
              MOTVE <span style={{ color: "#E8212A" }}>MODEL LINEUP</span>
            </h2>
            <p
              style={{
                fontFamily: "Sarabun, sans-serif",
                fontSize: "15px",
                color: "rgba(255,255,255,0.5)",
                marginTop: "12px",
              }}
            >
              คาลิปเปอร์ 6 ลูกสูบ — ออกแบบสำหรับทุกประเภทการใช้งาน
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
              gap: "28px",
            }}
          >
            {models.map((m) => (
              <div
                key={m.id}
                style={{
                  background: "#161616",
                  border: "1px solid rgba(255,255,255,0.07)",
                  borderRadius: "6px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  transition: "border-color 0.3s, transform 0.2s",
                }}
                onMouseEnter={(e) => {
                  const el = e.currentTarget as HTMLDivElement;
                  el.style.borderColor = "rgba(232,33,42,0.4)";
                  el.style.transform = "translateY(-4px)";
                }}
                onMouseLeave={(e) => {
                  const el = e.currentTarget as HTMLDivElement;
                  el.style.borderColor = "rgba(255,255,255,0.07)";
                  el.style.transform = "translateY(0)";
                }}
              >
                {/* Color bar */}
                <div style={{ height: "4px", background: m.badgeColor }} />

                {/* Image */}
                <div
                  style={{
                    background: "#111",
                    padding: "24px",
                    display: "flex",
                    justifyContent: "center",
                    borderBottom: "1px solid rgba(255,255,255,0.05)",
                  }}
                >
                  <img
                    src={m.img}
                    alt={`MOTVE ${m.name}`}
                    style={{ height: "180px", objectFit: "contain", maxWidth: "100%" }}
                  />
                </div>

                {/* Content */}
                <div style={{ padding: "24px", flex: 1, display: "flex", flexDirection: "column" }}>
                  {/* Header */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "16px" }}>
                    <div>
                      <p
                        style={{
                          fontFamily: "Rajdhani, sans-serif",
                          fontSize: "11px",
                          color: "rgba(255,255,255,0.4)",
                          letterSpacing: "0.2em",
                          textTransform: "uppercase",
                          marginBottom: "4px",
                        }}
                      >
                        MOTVE BRAKE
                      </p>
                      <h3
                        style={{
                          fontFamily: "Rajdhani, sans-serif",
                          fontSize: "40px",
                          fontWeight: 700,
                          color: "#fff",
                          lineHeight: 1,
                          marginBottom: "4px",
                        }}
                      >
                        {m.name}
                      </h3>
                      <p
                        style={{
                          fontFamily: "Rajdhani, sans-serif",
                          fontSize: "12px",
                          color: m.badgeColor,
                          fontWeight: 700,
                          letterSpacing: "0.1em",
                          textTransform: "uppercase",
                        }}
                      >
                        {m.type}
                      </p>
                    </div>
                    <span
                      style={{
                        padding: "4px 10px",
                        background: m.badgeColor,
                        color: "#fff",
                        fontFamily: "Rajdhani, sans-serif",
                        fontWeight: 700,
                        fontSize: "11px",
                        letterSpacing: "0.1em",
                        borderRadius: "2px",
                        flexShrink: 0,
                      }}
                    >
                      {m.badge}
                    </span>
                  </div>

                  <p
                    style={{
                      fontFamily: "Sarabun, sans-serif",
                      fontSize: "14px",
                      color: "rgba(255,255,255,0.65)",
                      lineHeight: 1.7,
                      marginBottom: "20px",
                      flex: 1,
                    }}
                  >
                    {m.desc}
                  </p>

                  {/* Spec Table */}
                  <div
                    style={{
                      background: "rgba(255,255,255,0.03)",
                      border: "1px solid rgba(255,255,255,0.07)",
                      borderRadius: "4px",
                      padding: "14px",
                      marginBottom: "16px",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "Rajdhani, sans-serif",
                        fontSize: "10px",
                        color: "#E8212A",
                        letterSpacing: "0.2em",
                        textTransform: "uppercase",
                        fontWeight: 700,
                        marginBottom: "10px",
                      }}
                    >
                      SPECIFICATIONS
                    </p>
                    {[
                      { label: "ลูกสูบ", value: m.spec.pistons },
                      { label: "พื้นที่ลูกสูบ", value: m.spec.area },
                      { label: "จานเบรก", value: m.spec.disc },
                      { label: "น้ำหนัก", value: m.spec.weight },
                    ].map((row) => (
                      <div
                        key={row.label}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "5px 0",
                          borderBottom: "1px solid rgba(255,255,255,0.04)",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "Sarabun, sans-serif",
                            fontSize: "12px",
                            color: "rgba(255,255,255,0.45)",
                          }}
                        >
                          {row.label}
                        </span>
                        <span
                          style={{
                            fontFamily: "Rajdhani, sans-serif",
                            fontSize: "13px",
                            fontWeight: 700,
                            color: "rgba(255,255,255,0.85)",
                          }}
                        >
                          {row.value}
                        </span>
                      </div>
                    ))}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        marginTop: "10px",
                      }}
                    >
                      <div
                        style={{
                          width: "6px",
                          height: "6px",
                          background: "#4ade80",
                          borderRadius: "50%",
                        }}
                      />
                      <span
                        style={{
                          fontFamily: "Sarabun, sans-serif",
                          fontSize: "12px",
                          color: "#4ade80",
                        }}
                      >
                        รับประกัน: {m.warranty}
                      </span>
                    </div>
                  </div>

                  {/* CTA */}
                  <a
                    href="https://lin.ee/usuFQKq"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      padding: "11px",
                      background: "#06C755",
                      color: "#fff",
                      textDecoration: "none",
                      fontFamily: "Rajdhani, sans-serif",
                      fontWeight: 700,
                      fontSize: "13px",
                      letterSpacing: "0.06em",
                      borderRadius: "3px",
                      transition: "background 0.2s",
                    }}
                    onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => {
                      (e.currentTarget as HTMLAnchorElement).style.background = "#04a344";
                    }}
                    onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => {
                      (e.currentTarget as HTMLAnchorElement).style.background = "#06C755";
                    }}
                  >
                    <SiLine size={14} /> สอบถาม LINE
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Color Options */}
      <section
        style={{
          background: "#111",
          borderTop: "1px solid rgba(232,33,42,0.15)",
          borderBottom: "1px solid rgba(232,33,42,0.15)",
          padding: "72px 0",
        }}
      >
        <div className="container mx-auto px-4">
          <div style={{ textAlign: "center", marginBottom: "48px" }}>
            <p
              style={{
                color: "#E8212A",
                fontSize: "13px",
                letterSpacing: "0.3em",
                textTransform: "uppercase",
                fontWeight: 700,
                marginBottom: "16px",
                fontFamily: "Rajdhani, sans-serif",
              }}
            >
              Custom Color
            </p>
            <h2
              style={{
                fontFamily: "Rajdhani, sans-serif",
                fontSize: "clamp(28px, 4vw, 44px)",
                fontWeight: 700,
                color: "#fff",
                marginBottom: "12px",
              }}
            >
              เลือกสีคาลิปเปอร์<span style={{ color: "#E8212A" }}>ได้ตามใจ</span>
            </h2>
            <p
              style={{
                fontFamily: "Sarabun, sans-serif",
                fontSize: "15px",
                color: "rgba(255,255,255,0.5)",
              }}
            >
              สามารถเลือกลายจานเบรกได้ตามต้องการ
            </p>
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "20px",
              maxWidth: "700px",
              margin: "0 auto",
            }}
          >
            {colorOptions.map((c) => (
              <div
                key={c.label}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "default",
                }}
              >
                <div
                  style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "50%",
                    background: c.color,
                    border: c.color === "#f4f4f5" || c.color === "#a1a1aa"
                      ? "2px solid rgba(255,255,255,0.2)"
                      : "2px solid rgba(255,255,255,0.06)",
                    boxShadow: `0 4px 20px ${c.color}40`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    transition: "transform 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLDivElement).style.transform = "scale(1.15)";
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLDivElement).style.transform = "scale(1)";
                  }}
                >
                  {c.emoji}
                </div>
                <span
                  style={{
                    fontFamily: "Sarabun, sans-serif",
                    fontSize: "13px",
                    color: "rgba(255,255,255,0.65)",
                  }}
                >
                  {c.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: "80px 0", textAlign: "center" }}>
        <div className="container mx-auto px-4">
          <p
            style={{
              color: "#E8212A",
              fontSize: "13px",
              letterSpacing: "0.3em",
              textTransform: "uppercase",
              fontWeight: 700,
              marginBottom: "16px",
              fontFamily: "Rajdhani, sans-serif",
            }}
          >
            สอบถามและจองคิว
          </p>
          <h2
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "clamp(24px, 4vw, 44px)",
              fontWeight: 700,
              color: "#fff",
              marginBottom: "16px",
            }}
          >
            อัพเกรดเบรกของคุณ<span style={{ color: "#E8212A" }}>วันนี้</span>
          </h2>
          <p
            style={{
              fontFamily: "Sarabun, sans-serif",
              fontSize: "16px",
              color: "rgba(255,255,255,0.55)",
              marginBottom: "40px",
              maxWidth: "460px",
              margin: "0 auto 40px",
            }}
          >
            ทักหา ENZO Performante Store เพื่อสอบถามรุ่นที่เหมาะกับรถของคุณ และจองคิวติดตั้ง
          </p>
          <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
            <a
              href="https://lin.ee/usuFQKq"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                padding: "14px 36px",
                background: "#06C755",
                color: "#fff",
                textDecoration: "none",
                fontFamily: "Rajdhani, sans-serif",
                fontWeight: 700,
                fontSize: "16px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                borderRadius: "3px",
              }}
            >
              <SiLine size={20} /> สอบถาม LINE
            </a>
            <a
              href="https://www.facebook.com/EnzoPerformanteStore/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                padding: "14px 36px",
                background: "#1877F2",
                color: "#fff",
                textDecoration: "none",
                fontFamily: "Rajdhani, sans-serif",
                fontWeight: 700,
                fontSize: "16px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                borderRadius: "3px",
              }}
            >
              <SiFacebook size={20} /> Facebook
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Index;
